import PropTypes from "prop-types";
import { ModuleSearchFilterItem } from ".";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModuleSearchFilterWrap({
  className = "",
  columns = [],
  filterData,
  setSearchData,
  changeFilter,
  bodyMoreFilter,
}) {
  return (
    <div className={classNames("flex w-full overflow-x-auto p-1", className)}>
      {columns.map((column) => (
        <ModuleSearchFilterItem
          key={column.params.name}
          filterData={filterData}
          changeFilter={changeFilter}
          options={column}
        />
      ))}

      {bodyMoreFilter}

      <Button
        className="p-button-main p-button-sm flex-shrink-0 py-1"
        type="button"
        label="查詢"
        onClick={() => setSearchData(filterData)}
      />
    </div>
  );
}

ModuleSearchFilterWrap.propTypes = {
  bodyMoreFilter: PropTypes.node,
  changeFilter: PropTypes.func,
  className: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      params: PropTypes.shape({
        name: PropTypes.string,
      }),
    })
  ),
  filterData: PropTypes.object,
  setSearchData: PropTypes.func,
};
